import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import {useNavigate, useParams} from "react-router-dom";
import styled from "styled-components";
import { getAllButtonByPartner } from "../../api/axios";
import CmsCircularProgress from "../Common/CircularProgress";
import CustomTable from "../Common/DataTable/DataTable";

export default function ButtonsView() {
    const { partnerId } = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const [buttons, setButtons] = useState([]);
  const navigate = useNavigate();

  const fetchButtons = async () => {
    try {
      const response = await getAllButtonByPartner(partnerId);
      console.log(response);
      setButtons(response.data.data);
      console.log(response.data.data[0]);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  
  useEffect(() => {
    fetchButtons();
  }, [partnerId]);

  const columns = [
    {
      text: "Page",
      width: "160px"
    },
    {
      text: "Position",
      width: "166px"
    },
    {
      text: "Button text",
      width: "199px"
    },
    {
      text: "Button link",
      width: "134px"
    },
    {
      text: "Edit Option",
      width: "137px"
    },
  ];  

  const rows = [];
  if(buttons?.length > 0) {
    buttons.forEach((button) => {
      rows.push([
        button.pageName, 
        button.pagePosition, 
        button.button_name, 
        button.buttonLink,
        (
          <div className="d-flex justify-content-center"> 
            <Button 
              variant="primary" 
              className="m-0"
              onClick={() => {
                console.log("clicked");
                navigate(`/${partnerId}/buttons/update/${button.id}`)
              }}
            >
              Edit
            </Button>
          </div>
        )
      ]);
    });
  }
  return (
    <>{isLoading ? <CmsCircularProgress/> :  <ContentWrapper>
      <ButtonsPageTitle>Buttons section</ButtonsPageTitle>
      {(!buttons?.length > 0 || buttons?.length !== 7) && <Button 
                    variant="primary" 
                    className="mb-3"
                    style={{ margin: "auto", width: "fit-content", display: "block" }}
                    onClick={() => {
                        console.log("clicked");
                        navigate(`/${partnerId}/buttons/update/create`)
                    }}
                  >
                    Add Buttons
                  </Button>}
      {buttons?.length > 0 && 
      <TableWrapper>
        <CustomTable columns={columns} rows={rows} />
      </TableWrapper>}
    </ContentWrapper>}
    </>
   
  );
}

const ContentWrapper = styled.div`
  @media (min-width:576px) {
    padding: 1rem;
    }
    @media (min-width:768px) {
   padding: 1.5rem;
  }
   padding: .5rem;
  justify-content: center;
`;

const ButtonsPageTitle = styled.h3`
  text-align: center;
  padding: 10px 0;
`;

const TableWrapper = styled.div`
  margin: 0 auto;
  overflow-x: auto;
`;





// const ButtonWrapper = styled.div`
//   margin: 0 auto;
// `;
